'use client';

import React from 'react';
import { Flex, Text, HStack, IconButton } from '@skin-seoul/design-system';
interface ProductQuantitySelectorProps {
  quantity: number;
  onQuantityChange: (increment: boolean) => void;
  productStatus?: string;
}
const ProductQuantitySelector = ({
  quantity,
  onQuantityChange,
  productStatus
}: ProductQuantitySelectorProps) => {
  return <Flex width="100%" justifyContent="space-between" alignItems="center" data-sentry-element="Flex" data-sentry-component="ProductQuantitySelector" data-sentry-source-file="ProductQuantitySelector.tsx">
      <Text textStyle="label.medium" color="neutral.400" data-sentry-element="Text" data-sentry-source-file="ProductQuantitySelector.tsx">
        Quantity
      </Text>
      <HStack backgroundColor="neutral.50" borderRadius="8px" paddingX={4} paddingY={1} height="40px" width="112px" justifyContent="space-between" alignItems="center" data-sentry-element="HStack" data-sentry-source-file="ProductQuantitySelector.tsx">
        <IconButton aria-label="Decrease quantity" size="sm" variant="ghost" onClick={() => onQuantityChange(false)} width="20px" height="20px" minWidth="20px" color={productStatus === 'outofstock' ? 'neutral.100' : 'neutral.400'} disabled={productStatus === 'outofstock'} data-sentry-element="IconButton" data-sentry-source-file="ProductQuantitySelector.tsx">
          <svg width="20" height="20" viewBox="0 0 20 20" fill="none" data-sentry-element="svg" data-sentry-source-file="ProductQuantitySelector.tsx">
            <path d="M4 10H16" stroke="currentColor" strokeWidth="1.5" strokeLinecap="round" strokeLinejoin="round" data-sentry-element="path" data-sentry-source-file="ProductQuantitySelector.tsx" />
          </svg>
        </IconButton>
        <Text textStyle="label.medium" color={productStatus === 'outofstock' ? 'neutral.300' : 'neutral.700'} data-sentry-element="Text" data-sentry-source-file="ProductQuantitySelector.tsx">
          {productStatus === 'outofstock' ? 0 : quantity}
        </Text>
        <IconButton aria-label="Increase quantity" size="sm" variant="ghost" onClick={() => onQuantityChange(true)} width="20px" height="20px" minWidth="20px" disabled={productStatus === 'outofstock'} color={productStatus === 'outofstock' ? 'neutral.100' : 'neutral.400'} data-sentry-element="IconButton" data-sentry-source-file="ProductQuantitySelector.tsx">
          <svg width="20" height="20" viewBox="0 0 20 20" fill="none" data-sentry-element="svg" data-sentry-source-file="ProductQuantitySelector.tsx">
            <path d="M10 4V16M4 10H16" stroke="currentColor" strokeWidth="1.5" strokeLinecap="round" strokeLinejoin="round" data-sentry-element="path" data-sentry-source-file="ProductQuantitySelector.tsx" />
          </svg>
        </IconButton>
      </HStack>
    </Flex>;
};
export default ProductQuantitySelector;